var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screener-graph"},[_c('span',{style:({ left: ((_vm.c - _vm.l) / (_vm.h - _vm.l)) * 100 + '%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }